export default class Landing {

    constructor(fito) {
        this.fito = fito;
    }

}
